import { useContext, useEffect, useState } from "react";
import { getPageEntries } from "utils/contentful/api";
import { DynamicComponent } from "components/checkout";
import Head from "next/head";
import { getSubscribeLayout } from "components/checkout/CheckoutContainer";
import { CheckoutContext } from "contexts/CheckoutProvider";
import CheckoutPersonalizationForm from "components/checkout/CheckoutPersonalizationForm";
import { extractPrimary } from "utils/contentful/helpers";
import useCheckoutValidator from "utils/hooks/useCheckoutValidator";
import LoadingAnimation from "@/atoms/account/LoadingAnimation";
import { FlowType } from "components/checkout/CheckoutContainer";
import { useRouter } from "next/router";
import { buildGuidedSignUpQueryString } from "utils/GuidedSignUp/getNavigationRoute";

function PersonalizeExperimentSwitch(props) {
  const router = useRouter();
  const { session } = useContext(CheckoutContext);
  const [flow, setFlow] = useState(null);

  // @FYI: we are maintaining the legacy subscribe flow for gifting specifically
  // @TODO: refactor funnel routing to decouple gifting
  useEffect(() => {
    if (!!session) {
      setFlow(
        !session.giftCode ? FlowType.GUIDED_SIGN_UP_FUNNEL : FlowType.SUBSCRIBE
      );
    }
  }, [session]);

  const { showPage, hydratedSession } = useCheckoutValidator({
    flow,
    withProperties: ["accountInfo"],
    redirectRoute: "/subscribe/",
  });

  useEffect(() => {
    if (session?.accountInfo && flow === FlowType.GUIDED_SIGN_UP_FUNNEL) {
      const queryParamString = buildGuidedSignUpQueryString({
        query: router?.query,
      });
      router.replace(`/subscribe/preferences/${queryParamString}`);
    }
  }, [flow, session]);

  return showPage && flow === FlowType.SUBSCRIBE ? (
    <Personalize {...props} />
  ) : null;
}

function Personalize({ cmsPage, routeNext }) {
  const flow = "subscribe";

  const { showPage } = useCheckoutValidator({
    flow,
    withProperties: ["accountInfo"],
    redirectRoute: "/subscribe/",
  });

  const { updateChildInfo, session } = useContext(CheckoutContext);
  const { sections, metaTitle } = cmsPage;
  const [primaryEntry, extraEntries] = extractPrimary(
    sections,
    "PersonalizationForm"
  );

  useEffect(() => {
    if (showPage) {
      window.dataLayer?.push({
        event: "createaccount",
        eventCategory: "KidsSubscription",
      });
    }
  }, [showPage]);

  const initialValues = {
    firstName: "",
    birthMonth: "",
    birthYear: "",
    ...(session?.personalization || {}),
  };

  return showPage ? (
    <>
      <Head>
        <title key="title">{metaTitle}</title>
      </Head>
      <CheckoutPersonalizationForm
        entry={primaryEntry}
        flow={flow}
        initialValues={initialValues}
        routeNext={routeNext}
        updateChildInfo={updateChildInfo}
      />
      {extraEntries.map((entry) => (
        <DynamicComponent key={entry.id} entry={entry} />
      ))}
    </>
  ) : (
    <LoadingAnimation />
  );
}

PersonalizeExperimentSwitch.getLayout = getSubscribeLayout;

export const getServerSideProps = async () => {
  const cmsPage = await getPageEntries("personalize");

  return {
    props: {
      cmsPage,
    },
  };
};

export default PersonalizeExperimentSwitch;
